import type { CSSProperties } from "react";

import type { ColorTheme } from "./theme";

const clerkCard: CSSProperties = {
  boxShadow: "none",
  border: "0",
  background: "transparent",
};

const clerkInput: CSSProperties = {
  borderRadius: "0px",
  border: "1px solid var(--rule-dark)",
  background: "var(--paper)",
  boxShadow: "none",
  minHeight: "42px",
  padding: "9px 11px",
};

const clerkElements = {
  rootBox: { width: "100%" },
  cardBox: clerkCard,
  card: clerkCard,
  headerTitle: { display: "none" },
  headerSubtitle: { display: "none" },
  formFieldLabel: {
    color: "var(--ink-soft)",
    fontSize: "0.7rem",
    fontWeight: "500",
  },
  formFieldInput: clerkInput,
  socialButtonsBlockButton: {
    border: "1px solid var(--ink)",
    boxShadow: "none",
    borderRadius: "0px",
    minHeight: "42px",
    background: "var(--paper-strong)",
    color: "var(--ink)",
  },
  socialButtonsBlockButtonText: {
    fontWeight: "650",
    color: "var(--ink)",
  },
  formButtonPrimary: {
    background: "var(--accent-fill)",
    color: "var(--accent-on)",
    border: "1px solid var(--accent-fill)",
    boxShadow: "none",
    fontWeight: "650",
    borderRadius: "0px",
    minHeight: "42px",
  },
  footer: {
    background: "transparent",
    boxShadow: "none",
    borderTop: "1px solid var(--rule)",
  },
  footerAction: { display: "none" },
};

export function clerkAuthAppearanceFor(
  theme: ColorTheme,
  options: { readonly hideClerkHeader?: boolean } = {},
) {
  const dark = theme === "dark";
  return {
    variables: {
      colorPrimary: dark ? "#ef6a42" : "#c2410c",
      colorTextOnPrimaryBackground: "#fff8f2",
      colorText: dark ? "#f3eee4" : "#1c1814",
      colorTextSecondary: dark ? "#a59c90" : "#6f675c",
      colorBackground: dark ? "#24201c" : "#faf7f2",
      colorInputBackground: dark ? "#2c2723" : "#fffdf8",
      colorInputText: dark ? "#f3eee4" : "#1c1814",
      colorDanger: dark ? "#e08a7a" : "#c45c4a",
      colorNeutral: dark ? "#a59c90" : "#6f675c",
      borderRadius: "0px",
      fontFamily: '"IBM Plex Sans Variable", sans-serif',
    },
    elements: {
      ...clerkElements,
      ...(options.hideClerkHeader === true
        ? { header: { display: "none" } }
        : {}),
    },
  };
}
